export default __webpack_public_path__ + "static/media/tela_backuppremium.a6b64eac.png";